import { useTranslation } from 'react-i18next'

import { useNavigate } from 'features/i18n/router'
import { ROUTE_PATH } from 'lib/paths'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxVipFeature = ({
  isActive,
  onClose,
}: {
  isActive: boolean
  onClose: any
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ConfirmBoxBasic
      isActive={isActive}
      title={t('confirm_box_vip_feature.title')}
      content={t('confirm_box_vip_feature.content')}
      confirmButtonText={t('confirm_box_vip_feature.confirm_button')}
      cancelText={t('confirm_box_vip_feature.cancel_button')}
      onClose={onClose}
      onCancel={onClose}
      onOk={() => {
        onClose()
        navigate(ROUTE_PATH.VIP_PURCHASE)
      }}
    />
  )
}

export default ConfirmBoxVipFeature
